<div class="informations-utiles">
	@if (afficherTitre()) {
		<div class="titre">
			{{ 'GESTION_NAVETTE.INFORMATIONS' | translate }}
		</div>
	}
	<div class="conteneur" [ngClass]="aucuneInformationsUtiles() ? 'texte-tertiaire' : ''">
		{{ aucuneInformationsUtiles() ? ('GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.INFORMATIONS_VIDES' | translate) : informations() }}
	</div>
</div>